import React from 'react';
import { useNavigate } from "react-router-dom";
import {Box, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import Header from "../common/HeaderMy";
import Cookies from 'js-cookie';


  export default function Execute() {
	const navigate = useNavigate();

	  function logout(){
		Cookies.remove('isrwadminloggedin');
		navigate('/login');
	  }

	 return (
		<div> 
				<MetaTags>
            		<title>Session Expired</title>
          		</MetaTags>
				
			    <Header hamburger={false} pageTitle="Session Expired" />

				<Box className='mainBox'>	

					<div style={{textAlign:'center'}}>
							<h3>
								<span>Oops! Your session has been expired.<br/>
								OR<br/>
								Another person has been logged-in on another device with your user id.</span>
								<br/>
								<span style={{color:'#FF0000'}}>Alert: One user can login with one user id at once.</span>
							</h3>
									<br/>

							<Button onClick={() => {logout()}} size="small" variant="outlined" style={{backgroundColor:'#0d6fec', color:'#FFF', textTransform: 'none'}} >Login Again</Button>

					</div>

				</Box>
				
					
			
		</div>	
	);
  }